import React, { useState, createContext, useEffect } from "react";
let loaderContext = createContext();

export default loaderContext;

export let LoaderProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("bus");
  const [activeDD, setActiveDD] = useState(false);

  useEffect(() => {
    if (window !== undefined) {
      // Check for education portal persistence first
      const educationPortalActive = localStorage.getItem(
        "educationPortalActive"
      );
      if (educationPortalActive === "true") {
        setSelectedMenu("education");
      } else {
        const lsSelectedMenu = localStorage.getItem("selectedMenu");
        if (Boolean(lsSelectedMenu)) {
          setSelectedMenu(lsSelectedMenu);
        }
      }
    }
  }, [selectedMenu, activeDD]);

  return (
    <loaderContext.Provider
      value={{
        loader,
        setLoader,
        selectedMenu,
        setSelectedMenu,
        activeDD,
        setActiveDD,
      }}
    >
      {children}
    </loaderContext.Provider>
  );
};
